module.exports = __webpack_public_path__ + "static/media/taskeen-logo.5d436c80.svg";